// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    SetFilterQuery,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import cloneDeep from "lodash/cloneDeep"
import qs from "qs";



export const XngSetFilterQuery: typeof SetFilterQuery = props => {
    const queryObject = cloneDeep(props.getState().pages.productList.productFilters);
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    // XNG-Changes
    if (getCurrentPage(props.getState()).type === "RecentlyPurchasedPage") {
        delete queryObject.previouslyPurchasedProducts;
    }

    props.result = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });

};

replaceInChain(chain, SetFilterQuery, XngSetFilterQuery);
